import type { FunctionComponent } from 'react';

import { Field } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';
import { FinanceRate } from '@kanda-libs/ks-frontend-services';

import useJobForm from './useJobForm';

export interface JobFormProps {
  rates: FinanceRate[];
  bnplRates?: FinanceRate[];
}

const JobForm: FunctionComponent<JobFormProps> = function ({
  rates,
  bnplRates,
}) {
  const { price, aprLabel, durations, deposits } = useJobForm(rates, bnplRates);
  return (
    <div>
      <Text
        text={`Finance Type: ${aprLabel}`}
        className="block mb-8 text-16-24"
      />
      <Field.NumberInput
        name="price"
        type="price"
        label="Enter a job price to see rates and a breakdown"
      />
      {price && price !== 0 ? (
        <>
          <Field.Select
            name="duration"
            options={durations}
            label="Select Duration"
          />
          <Field.Select
            name="deposit"
            options={deposits}
            label="Select Deposit"
          />
        </>
      ) : null}
    </div>
  );
};

export default JobForm;
